<template>
  <el-cascader v-if="type === 'select'" v-bind="$attrs" class="j-profession-select" v-model="profession" :options="professionArray" @change="professionChange" :separator="textSeparator" :clearable="clearable" />
  <span v-else class="j-profession-text">{{professionText}}</span>
</template>

<script>
import JProfessionMixins from './mixins'
export default {
  name: "JProfession",
  mixins: [JProfessionMixins],
  props: {
    value: {
      type: [String, Array],
      default: ''
    },
    type: { // ['text', 'select']
      type: String,
      default: 'text'
    },
    clearable: {
      type: Boolean,
      default: true
    },
    textSeparator: { // 文本分隔符
      type: String,
      default: '/'
    },
    separator: { // 父子字段分割
      type: String,
      default: ','
    },
    valueType: { // String/Array 返回类型
      type: String,
      default: 'String'
    }
  },
  watch: {
    value (nv) {
      this.updateData(nv)
    }
  },
  data () {
    return {
      profession: [],
      professionText: ''
    }
  },
  created() {
    this.updateData(this.value)
  },
  methods: {
    updateText () {
      this.professionText = this.profession.map(key => this.professionMap[key] || key).join(this.textSeparator)
    },
    updateData (value) {
      if (Array.isArray(value)) this.profession = value
      else this.profession = String(value).split(this.separator)
      if (this.type !== 'select') this.updateText()
    },
    professionChange (v) {
      if (this.valueType === 'Array') this.$emit('input', v)
      else this.$emit('input', v.join(this.separator))
      this.$emit('change', v, v.map(i => this.professionMap[i]))
    }
  }
}
</script>

<style lang="scss">
.j-profession-select {
  width: 100%;
}
</style>
